interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
  type: "success" | "error";
}

export const ErrorSuccessModal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  message,
  type,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-xl shadow-lg w-96 border border-gray-200">
        <h2
          className={`text-lg font-bold mb-2 ${type === "success" ? "text-green-600" : "text-red-600"}`}
        >
          {title}
        </h2>
        <p className="text-gray-700 mb-6">{message}</p>
        <button
          onClick={onClose}
          className="w-full py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-900"
        >
          Κλείσιμο
        </button>
      </div>
    </div>
  );
};
